import { defineMessages } from 'react-intl';

export default defineMessages({
  name: 'Nazwa baterii/testu',
  perfomedTests: 'Wykonane testy',
  batteryName: 'Nazwa baterii',
  testName: 'Nazwa testu',
});
